import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "userCard" }
const _hoisted_2 = {
  key: 0,
  class: "userCard__header"
}
const _hoisted_3 = { class: "userCard__body" }
const _hoisted_4 = {
  key: 0,
  style: {"width":"100%","padding-bottom":"10px"}
}
const _hoisted_5 = { class: "iconBlock" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon-pin" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "icon-phone" }, null, -1)
const _hoisted_12 = { key: 2 }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-mobile" }, null, -1)
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "iconBlock" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "icon-fax" }, null, -1)
const _hoisted_18 = { key: 4 }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "icon-envelope-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.data.firstname)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.data.firstname) + " " + _toDisplayString(_ctx.data.lastname), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.aboutUs.content.riumAdministratorForAreaText")), 1)
      ]),
      _createElementVNode("ul", null, [
        (_ctx.data.location)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.item.street) + " ", 1),
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.item.postalCode) + " ", 1),
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.item.city), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.phone)
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              _createElementVNode("a", {
                href: 'tel:' + _ctx.data.phone,
                class: "iconBlock"
              }, [
                _hoisted_11,
                _createElementVNode("span", null, _toDisplayString(_ctx.data.phone), 1)
              ], 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.mobile)
          ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
              _createElementVNode("a", {
                href: 'tel:' + _ctx.data.mobile,
                class: "iconBlock"
              }, [
                _hoisted_14,
                _createElementVNode("span", null, _toDisplayString(_ctx.data.mobile), 1)
              ], 8, _hoisted_13)
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.fax)
          ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("span", null, _toDisplayString(_ctx.data.fax), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.email)
          ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
              _createElementVNode("a", {
                href: 'mailto:' + _ctx.data.email,
                class: "iconBlock"
              }, [
                _hoisted_20,
                _createElementVNode("span", null, _toDisplayString(_ctx.data.email), 1)
              ], 8, _hoisted_19)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}